<template>
  <div class="container">
    <div class="left">
      <h1 class="company-title">{{$t('contact.companyInfo.contactUs')}}</h1>
      <div class="company-info-container">
        <div class="company-info-item">
          <span class="iconfont icon-dingwei-mianxing"></span>
          <div>
            <h2>{{$t('contact.companyInfo.h2.01')}}</h2>
            <p>{{$t('contact.companyInfo.p.01')}}</p>
          </div>
        </div>
        <div class="company-info-item">
          <span class="iconfont icon-dianhua-mianxing"></span>
          <div>
            <h2>{{$t('contact.companyInfo.h2.02')}}</h2>
            <p>{{$t('contact.companyInfo.p.02')}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="card-server">
        <h1>{{$t('contact.companyInfo.cardServer.h1')}}</h1>
        <p>{{$t('contact.companyInfo.cardServer.p')}}</p>
        <div class="server-time-item"><span>{{$t('contact.companyInfo.cardServer.div1.span1')}}</span><span>{{$t('contact.companyInfo.cardServer.div1.span2')}}</span></div>
        <div class="server-time-item"><span>{{$t('contact.companyInfo.cardServer.div2.span1')}}</span><span>{{$t('contact.companyInfo.cardServer.div2.span2')}}</span></div>
        <div class="server-time-item"><span>{{$t('contact.companyInfo.cardServer.div3.span1')}}</span><span>{{$t('contact.companyInfo.cardServer.div3.span2')}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
@import url("../../../assets/iconfont/iconfont.css");
.container {
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  background-color: #f1f3fa;
  padding: 120px 0;
  .left {
    .company-title {
      color: #ff5d1b;
    }
    .company-info-container{
        display: flex;
        .company-info-item{
            margin-right: 24px;
            display: flex;
            justify-content: center;
            align-items: center;

            .iconfont{
                margin-right: 24px;
                font-size: 48px;
            }
        }
    }
  }

  .right {
    .card-server {
      padding: 24px;
      color: #fff;
      background-color: #ff5d1b;
      border: 4px solid #fff;

      h1 {
        font-weight: bold;
        color: #fff;
      }
      .server-time-item {
        padding: 6px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #fff;
      }
    }
  }
}
</style>